import mongoose from 'mongoose';
import { getVal, phoneNumberClearValue } from '../../../../shared/helpers';

export const Lead_create_schema = new mongoose.Schema({
    ref_lead_source: {
        type: mongoose.Schema.Types.ObjectId,
        required: [true, 'Division is required'],
    },
    marketing: {
        required: true,
        default: {},
        type: new mongoose.Schema({
            source: {
                required: true,
                default: 'CRM',
                type: String,
            },
        }),
    },
    ref_lead_customer: {
        required: true,
        default: {},
        type: new mongoose.Schema({
            full_name: {
                type: String,
                required: [true, 'Name is required'],
                set(value) {
                    return value.trim();
                },
            },
            phone: {
                type: String,
                required: [true, 'Phone is required'],
                validate:
                    {
                        validator(v) {
                            return /[0][1-3,7][0-9]{9}$/gm.test(v.trim());
                        },
                        message: props => `${props.value} is not a valid phone number! (e.x. 07312341234)`,
                    },
                set(value) {
                    return phoneNumberClearValue(value).trim();
                },
            },
            email: {
                type: String,
                required: [true, 'Email is required'],
                validate:
                    {
                        validator(v) {
                            return /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i.test(v);
                        },
                        message: props => `${props.value} is not a valid email! (e.x. awesomebike@gmail.com)`,
                    },
                set(value) {
                    return value.trim();
                },
            },
            address: {
                county: {
                    type: mongoose.Schema.Types.ObjectId,
                },
            },
            preferred_contact_method: {
                type: String,
                set(value) {
                    if (value === 'Email' || value === 'SMS') {
                        this.set({ preferred_contact_time: undefined });
                    }
                    return value;
                },
            },
            preferred_contact_time: {
                type: String,
                // 'Any','Telephone','Email', 'SMS'

            },
        }),
    },
    ref_bike_lead: {
        required: true,
        default: {},
        type: new mongoose.Schema({
            vrm: {
                type: String,
                required: [true, 'Bike vrm is required'],
                // default: 'AV62 CCY',
                // default: 'PO63UUF',
                // default: "MX16KFP",
                set(value) {
                    return value.trim();
                },
            },
            ref_bike_brand: {
                type: mongoose.Schema.Types.ObjectId,
                required: [true, 'Bike make is required'],
            },
            ref_bike_model: {
                type: mongoose.Schema.Types.ObjectId,
                required: [
                    function () {
                        if (this.$parent) {
                            return getVal(this, 'unmaped_data.bike_model') === undefined;
                        }
                        return getVal(this, 'ref_bike_lead.unmaped_data.bike_model') === undefined;
                    },
                    'Bike model is required, select make at first',
                ],
                set(model) {
                    if (model !== undefined && model !== 'undefined') {
                        this.set({
                            'temporary.bike_cc': model.cc,
                            'temporary.bike_model_variant': model.model_variation,
                        });
                    }

                    let value = (model === undefined || model === 'undefined') && undefined;

                    if (value !== undefined && value !== 'undefined') {
                        if (mongoose.Types.ObjectId.isValid(model)) {
                            value = model;
                        } else {
                            value = model._id;
                        }
                    }

                    return value;
                },
            },
            ref_bike_variant: {
                type: mongoose.Schema.Types.ObjectId,
            },
            temporary: {
                type: new mongoose.Schema({
                    bike_model_variant: {
                        type: String,
                        maxLength: 255,
                        set(value) {
                            this.set({ 'unmaped_data.bike_model_variant': value });
                            return value;
                        },
                    },
                    bike_cc: {
                        type: Number,
                        set(value) {
                            return value;
                        },
                    },
                    bike_year: {
                        type: Number,
                    },
                }),
            },
            unmaped_data: {
                default: {},
                type: new mongoose.Schema({
                    bike_model: {
                        type: String,
                        maxLength: 255,
                        set(value) {
                            this.$parent.set({ ref_bike_model: undefined });
                            this.$parent.set({ ref_bike_variant: undefined });
                            return value;
                        },
                    },
                    bike_model_variant: {
                        type: String,
                        maxLength: 255,
                        set(value) {
                            this.$parent.set({ 'temporary.bike_model_variant': undefined });
                            this.$parent.set({ ref_bike_variant: undefined });
                            return value;
                        },
                    },
                    bike_cc: {
                        type: Number,
                        set(value) {
                            return value;
                        },
                    },
                    bike_year: {
                        type: Number,
                    },
                }),
            },
            bike_year: {
                type: Number,
                required: [true, 'Bike Year is required'],
                default: '',
            },
            mileage: {
                type: Number,
                required: [true, 'Mileage is required'],
                default: '',
            },
            non_runner: {
                type: String,
                required: [true, 'Non-runner is required'],
                default: 'No',
                enum: ['No', 'Yes', 'Just needs a battery', 'Not Captured'],
            },
            document_history: {
                type: String,
                required: [true, 'Service history is required'],
                default: 'Full History',
                enum: ['Full History', 'Part History', 'First not due', 'No History', 'Not Captured'],
            },
            mot_history_customer: {
                type: String,
                required: [true, 'MOT history is required'],
                default: 'Over 1 month',
                enum: ['Over 1 month', 'Under 1 month', 'Not required', 'Expired'],
            },
            race_replica: {
                type: Boolean,
                required: true,
                default: false,
            },
            has_abs: {
                type: Boolean,
                required: false,
                default: false,
            },
            panniers: {
                type: Boolean,
                required: true,
            },
            colour: {
                type: String,
                default: '',
            },
            previous_owner_count: {
                type: Number,
                default: '0',
            },
            written_off: {
                type: Boolean,
                default: false,
            },
            condition: {
                type: String,
                enum: ['1 - Very Poor', '2 - Below Average', '3 - Average', '4 - Good', '5 - Showroom Condition', 'Not Captured'],
            },
            upgrades: [{
                _id: {
                    type: mongoose.Schema.Types.ObjectId,
                },
                ref_bike_lead_upgrades: {type: mongoose.Schema.Types.ObjectId, ref: 'bike_lead_upgrades'},
                additional_mod: String
            }]
        }),
    },
    part_ex: {
        required: true,
        default: {},
        type: new mongoose.Schema({
            is_part_ex: {
                type: Boolean,
                required: true,
                default: false,
            },
            ref_bike_inventory: {
                type: mongoose.Schema.Types.ObjectId,
            },
        }),
    },
    lead_pot: {
        type: String,
        required: false,
        enumValues: ['Unknown', 'Green', 'Amber', 'Red'],
    },
    min_age: {
        type: Number,
        required: false,
    },
    maximum_mileage: {
        type: Number,
        required: false,
    },
    is_bike_we_want: {
        type: Boolean,
        required: false,
        default: true,
    },
    match_type: {
        type: String,
        required: false,
    },
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/schema/mongooseSchema.js